import PropTypes from "prop-types";
import cx from "classnames";
import * as React from "react";

export const SECTION_PROMPT_PROPS = {
  sizes: ["large", "medium", "small"]
};

const SectionPrompt = ({
  title,
  titleId,
  description,
  help,
  divider,
  children,
  contentStyle,
  containerStyle,
  require
}) => {
  const baseClass = "ocn-section-prompt";
  const dividerClass = divider && `${baseClass}-divider`;
  const requireClass = `${baseClass}-require`;

  // Create the title element with a red asterisk if required
  const titleElement = (
    <>
      {title}
      {require && <span className={requireClass}>*</span>}
    </>
  );

  const descriptionElement = (
    <>
      {description}
      {require && <span className={requireClass}>*</span>}
    </>
  );

  return (
    <div className={cx(`${baseClass}`, dividerClass)} style={containerStyle}>
      <div className={`${baseClass}-text`}>
        {title && (
          <div id={titleId} className={`${baseClass}-text-title`}>
            {titleElement}
          </div>
        )}
        {description && <div className={`${baseClass}-text-description`}>{descriptionElement}</div>}
      </div>
      <div className={`${baseClass}-content`} style={contentStyle}>
        {children}
      </div>
    </div>
  );
};

SectionPrompt.propTypes = {
  /**
   * prompt is the bold section message
   */
  prompt: PropTypes.string,

  /**
   * id for the title, so a control can reference it with aria-labelledby
   */
  titleId: PropTypes.string,

  /**
   * prompt is the light description message under the prompt
   */
  description: PropTypes.string,

  /**
   * help is the info text that will add a ? help icon with tool tip explanation
   */
  help: PropTypes.string,

  /**
   * content to display within the section
   */
  children: PropTypes.node,

  /**
   * size modifier controlling relative size of prompt and description font size and spacing
   */
  size: PropTypes.oneOf(SECTION_PROMPT_PROPS.sizes),

  /**
   * adds divider at the end of section
   */

  divider: PropTypes.bool
};

export default SectionPrompt;
